import React from 'react';
import { Shield, Lock, FileCheck } from 'lucide-react';

const Security = () => {
  return (
    <section id="security" className="py-24 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 data-grid opacity-30"></div>
      <div className="absolute top-1/3 right-0 w-64 h-64 bg-blue-300/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/3 left-0 w-64 h-64 bg-purple-300/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 max-w-6xl mx-auto">
          {/* Left Content */}
          <div className="flex-1">
            <div className="inline-block px-3 py-1 mb-6 bg-blue-100 text-blue-600 rounded-full text-sm font-medium reveal opacity-0 transition-all duration-700 translate-y-8">
              Enterprise Security
            </div>
            <h2 className="heading-lg mb-6 reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '100ms' }}>
              Enterprise-grade security for your sensitive data
            </h2>
            <p className="text-gray-600 text-lg mb-8 reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '200ms' }}>
              Portco AI is built with security-first architecture, ensuring your investment data is protected with the highest industry standards.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4 reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '300ms' }}>
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Lock className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2">End-to-end encryption</h3>
                  <p className="text-gray-600">Your data is encrypted in transit and at rest using industry-standard encryption protocols.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '400ms' }}>
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Shield className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2">Private and secure</h3>
                  <p className="text-gray-600">We never train our AI models on customer data, ensuring your information remains completely private.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '500ms' }}>
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <FileCheck className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2">SOC 2 Type II Certification</h3>
                  <p className="text-gray-600">We are in the final stages of obtaining our SOC 2 Type II certification, expected to be completed in Q2 2024.</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right Image/Badge */}
          <div className="lg:flex-1 w-full lg:w-auto reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '600ms' }}>
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-3xl transform rotate-6"></div>
              <div className="relative bg-white p-8 rounded-3xl shadow-xl border border-gray-100">
                <div className="aspect-square w-full max-w-md mx-auto">
                  <div className="w-full h-full bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center p-8">
                    <div className="text-white text-center">
                      <Shield className="w-20 h-20 mx-auto mb-4" />
                      <h3 className="text-2xl font-bold mb-2">SOC 2</h3>
                      <p className="text-blue-100">Certification In Progress</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Security; 